import { render } from "./InformeVentas.vue?vue&type=template&id=40177973&scoped=true"
import script from "./InformeVentas.vue?vue&type=script&lang=js"
export * from "./InformeVentas.vue?vue&type=script&lang=js"

import "./InformeVentas.vue?vue&type=style&index=0&id=40177973&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40177973"]])

export default __exports__